import React from "react";
import UserCurrentNewsItems from "./UserCurrentNewsItems";

const UserCurrentNewsFun = ({ newsData }) => {
  if (!newsData || newsData.length === 0) {
    return (
      <div style={{ color: "#aaa", textAlign: "center" }}>
        No news available.
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      {newsData.map((post) => (
        <UserCurrentNewsItems key={post.id} post={post} />
      ))}
    </div>
  );
};

export default UserCurrentNewsFun;
